module.exports = __webpack_public_path__ + "static/media/AvatarMaestra.6bf5209e.jpg";